<template>
  <div id="crew-page-layout">
    <!-- アラート表示領域 -->
    <crew-alert-component
      ref="alertComponent"
      :alertList="alertList"
      :alertTileWidth="alertTileWidth"
      @jumpFromAlert="jumpFromAlert"
    />

    <!-- 労務ダッシュボード表示領域 -->
    <div
      class="crew-page-layout-card vs-con-loading__container"
      v-if="this.isRouteCrewStatusList"
    >
      <crew-status-list ref="crewStatusList" />
    </div>

    <!-- vx-card表示領域 -->
    <div
      class="vx-card crew-page-layout-card vs-con-loading__container"
      v-if="!this.isRouteCrewStatusList"
    >
      <!-- 一覧タブ切替え領域 -->
      <!-- タブのヘッダー -->
      <div class="card-top-tab-area flex items-center">
        <ul class="tabs">
          <template v-if="dispType === 'labor'">
            <li
              v-for="(tab, index) in filteredTabInfo.labor"
              :key="tab.dom_id"
              :class="{ active: index === activeTab }"
              class="flex justify-center items-center"
              @click="jumpFromTab('labor', index)"
            >
              <img :src="getIconFromIconMap(tab.icon)" />
              <span
                class="ml-2 whitespace-no-wrap aisea-text-16-400-dark-gray"
                >{{ tab.title }}</span
              >
            </li>
          </template>
          <template v-if="dispType === 'corporate'">
            <li
              v-for="(tab, index) in filteredTabInfo.corporate"
              :key="tab.dom_id"
              :class="{ active: index === activeTab }"
              class="flex justify-center items-center"
              @click="jumpFromTab('corporate', index)"
            >
              <img :src="getIconFromIconMap(tab.icon)" />
              <span
                class="ml-2 whitespace-no-wrap aisea-text-16-400-dark-gray"
                >{{ tab.title }}</span
              >
            </li>
          </template>
        </ul>
        <!-- 右上船員アバター表示領域 -->
        <div
          v-if="dispType === 'labor'"
          class="flex justify-end items-center flex-no-wrap ml-auto mr-2"
        >
          <div
            class="mr-2 flex justify-center items-center increment-user-button"
            :style="{
              color: hasPrevCrew ? AISEA_COLOR.GRAY : AISEA_COLOR.LIGHT_GRAY,
              cursor: hasPrevCrew ? 'pointer' : null,
            }"
            @click="onClickPrevCrew"
          >
            <vs-icon icon="chevron_left" class="mb-1" size="25px" />
          </div>
          <div v-if="isRetirement" style="height: 24px;">
            <!-- 退職済バッジ -->
            <span class="retirement-badge">退職済</span>
          </div>
          <p class="text-inherit mx-2 whitespace-no-wrap">
            <span class="aisea-text-14-400-black">{{ avatarName }}</span>
          </p>
          <vs-avatar
            :src="avatar"
            :text="avatarInitials"
            class="flex-shrink-0 ml-2"
            size="30px"
            style="cursor: default;"
            :color="AISEA_COLOR.LIGHT_BLUE"
          />
          <div
            class="ml-2 flex justify-center items-center increment-user-button"
            :style="{
              color: hasNextCrew ? AISEA_COLOR.GRAY : AISEA_COLOR.LIGHT_GRAY,
              cursor: hasNextCrew ? 'pointer' : null,
            }"
            @click="onClickNextCrew"
          >
            <vs-icon icon="chevron_right" class="mb-1" size="25px" />
          </div>
        </div>
      </div>
      <div
        class="p-6 pt-2 h-full uk-position-relative crew-page-layout-tab-area"
      >
        <template v-if="dispType === 'labor'">
          <!-- v-if による弊害が起きないか検証 -->
          <div v-if="activeTab === 0" class="w-full h-full">
            <!-- 勤怠情報 RE-1 領域 -->
            <crew-labor-record
              :enterpriseCrewId="$route.params.id"
              :key="enterpriseCrewId"
              :active="activeTab === 0"
            />
          </div>
          <div v-if="activeTab === 1" class="w-full h-full">
            <!-- 打刻記録 PA-1 領域 -->
            <crew-timesheet-list
              ref="crewTimesheetlList"
              v-if="enterpriseCrewId"
              :key="enterpriseCrewId"
              :enterpriseCrewId="enterpriseCrewId"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
              @setActiveTab="activeTab = $event"
            />
          </div>
          <div v-if="activeTab === 2" class="w-full h-full">
            <!-- 乗船期間 CA-1 領域 -->
            <manning-vessels-list
              ref="manningVesselslList"
              :key="enterpriseCrewId"
              v-if="enterpriseCrewId"
              :enterpriseCrewId="enterpriseCrewId"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
              @checkAlert="checkAlert"
              @setActiveTab="activeTab = $event"
            />
          </div>
          <div v-if="activeTab === 3" class="w-full h-full">
            <!-- 労務情報 CC-1 領域 -->
            <crew-labors
              v-if="enterpriseCrewId"
              :enterpriseCrewId="enterpriseCrewId"
              :key="enterpriseCrewId"
              ref="CrewLabors"
              :activeSidebarCrew.sync="activeSidebarCrew"
              :activeTab="activeTab"
              @checkAlert="checkAlert"
              @setDialogTitle="setDialogTitle"
            ></crew-labors>
          </div>
          <div v-if="activeTab === 4" class="w-full h-full">
            <!-- 船員基本情報 CP-1 領域 -->
            <crew-profile
              ref="CrewProfile"
              v-if="enterpriseCrewId"
              :enterpriseCrewId="enterpriseCrewId"
              :key="enterpriseCrewId"
              :activeSidebarCrew.sync="activeSidebarCrew"
              :activeTab="activeTab"
              @checkAlert="checkAlert"
              @setDialogTitle="setDialogTitle"
            ></crew-profile>
          </div>
        </template>
        <template v-if="dispType === 'corporate'">
          <div v-if="activeTab === 0" class="w-full h-full">
            <!-- 労務基本情報 M-3 領域 -->
            <crew-labor-template
              ref="LaborTemplate"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
              @checkAlert="checkAlert"
            ></crew-labor-template>
          </div>
          <div v-if="activeTab === 1" class="w-full h-full">
            <!-- 船舶情報 M-2 領域 -->
            <vessels-list
              ref="vesselsList"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
              @checkAlert="checkAlert"
            />
          </div>
          <div v-if="activeTab === 2" class="w-full h-full">
            <!-- 船員一覧 CL-1 領域 -->
            <crew-list
              ref="crewList"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
              @checkAlert="checkAlert"
            />
          </div>
          <div v-if="activeTab === 3" class="w-full h-full">
            <!-- 陸上従業員 EL-1 領域 -->
            <admin-account-list
              ref="adminAccountList"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
            />
          </div>
          <div v-if="activeTab === 4" class="w-full h-full">
            <corp-manning-vessels-list
              ref="corpManningVesselslList"
              :enterpriseCrewId="enterpriseCrewId"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
              @checkAlert="checkAlert"
              @setActiveTab="activeTab = $event"
            />
          </div>
          <div v-if="activeTab === 5" class="w-full h-full">
            <task-kind-list
              ref="taskKindList"
              :enterpriseCrewId="enterpriseCrewId"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
              @checkAlert="checkAlert"
              @setActiveTab="activeTab = $event"
            />
          </div>
          <div v-if="showDataManagement" class="w-full h-full">
            <data-management
              :enterpriseCrewId="enterpriseCrewId"
              :activeTab="activeTab"
              :activeSidebarCrew.sync="activeSidebarCrew"
              @setDialogTitle="setDialogTitle"
              @checkAlert="checkAlert"
              @setActiveTab="activeTab = $event"
            />
          </div>
        </template>
      </div>
    </div>

    <!-- サイドバー -->
    <crew-controls-sidebar
      v-if="!this.isRouteCrewStatusList"
      :activeSidebarCrew.sync="activeSidebarCrew"
      :dialogTitle="dialogTitle"
    >
      <template v-slot:crewControlSidebarBody>
        <template v-if="dispType === 'labor'">
          <div v-if="activeSidebarCrew && activeTab === 0">
            <!-- 勤怠情報 詳細 -->
          </div>
          <div v-if="activeSidebarCrew && activeTab === 1">
            <!-- 打刻記録 詳細 -->
            <crew-timesheet-edit
              :inputParam="$refs.crewTimesheetlList.crewTimesheetParam"
              :activeSidebarCrew="activeSidebarCrew"
              @close="activeSidebarCrew = false"
              @reloadList="$refs.crewTimesheetlList.reloadList"
              @updatedId="$refs.crewTimesheetlList.updatedId($event)"
            />
          </div>
          <div v-if="activeSidebarCrew && activeTab === 2" class="h-full">
            <!-- 乗船期間 詳細 -->
            <manning-vessel-crew-edit
              :inputParam="$refs.manningVesselslList.manningVesselCrewParam"
              :activeSidebarCrew="activeSidebarCrew"
              @close="activeSidebarCrew = false"
              @reloadList="$refs.manningVesselslList.reloadList"
              @updatedId="$refs.manningVesselslList.updatedId($event)"
            />
          </div>
          <div v-if="activeSidebarCrew && activeTab === 3">
            <!-- 労務情報 詳細 -->
            <crew-labors-edit
              :inputParam="$refs.CrewLabors.crewLaborsParam"
              :activeSidebarCrew="activeSidebarCrew"
              @close="activeSidebarCrew = false"
              @checkAlert="checkAlert"
            />
          </div>
          <div v-if="activeSidebarCrew && activeTab === 4">
            <div
              v-if="
                $refs.CrewProfile.isSelectedItem(
                  $refs.CrewProfile.sidebarItemEnum.editProfile
                )
              "
            >
              <!-- 船員基本情報編集 -->
              <crew-basic-info-edit
                :inputParam="$refs.CrewProfile.crewProfileParam"
                :activeSidebarCrew="activeSidebarCrew"
                :fromPage="'CrewProfile'"
                @close="activeSidebarCrew = false"
                @reloadList="$refs.CrewProfile.reloadList"
              />
            </div>
            <div
              v-else-if="
                $refs.CrewProfile.isSelectedItem(
                  $refs.CrewProfile.sidebarItemEnum.editAccount
                )
              "
            >
              <!-- パスワード変更, アプリアカウント発行 -->
              <crew-account-edit
                :inputParam="$refs.CrewProfile.crewProfileParam"
                :activeSidebarCrew="activeSidebarCrew"
                @close="activeSidebarCrew = false"
                @reloadList="$refs.CrewProfile.reloadList"
                @setDialogTitle="setDialogTitle"
              />
            </div>
            <div v-else>
              <!-- 退職処理 -->
              <crew-retirement-edit
                :inputParam="$refs.CrewProfile.crewProfileParam"
                :activeSidebarCrew="activeSidebarCrew"
                @close="activeSidebarCrew = false"
                @reloadList="$refs.CrewProfile.reloadList"
              />
            </div>
          </div>
        </template>
        <template v-if="dispType === 'corporate'">
          <div v-if="activeSidebarCrew && activeTab === 0">
            <!-- 労務基本情報 詳細 -->
            <crew-labor-template-edit
              :inputParam="$refs.LaborTemplate.crewLaborTemplateParam"
              :activeSidebarCrew="activeSidebarCrew"
              @close="activeSidebarCrew = false"
              @updatedId="$refs.LaborTemplate.updatedId($event)"
            />
          </div>
          <div v-if="activeSidebarCrew && activeTab === 1">
            <!-- 船舶情報 詳細 -->
            <vessel-edit
              :inputParam="$refs.vesselsList.manningVesselBasicInfoParam"
              :activeSidebarCrew="activeSidebarCrew"
              @close="$refs.vesselsList.closeSidebarCrew($event)"
              @reloadList="$refs.vesselsList.reloadList"
              @updatedId="$refs.vesselsList.updatedId($event)"
            />
          </div>
          <div v-if="activeSidebarCrew && activeTab === 2">
            <!--  船員情報 詳細 -->
            <crew-basic-info-edit
              :inputParam="$refs.crewList.crewBasicInfoParam"
              :activeSidebarCrew="activeSidebarCrew"
              @close="$refs.crewList.closeSidebarCrew($event)"
              @reloadList="$refs.crewList.reloadList"
              @updatedId="$refs.crewList.updatedId($event)"
            />
          </div>
          <div v-if="activeSidebarCrew && activeTab === 3">
            <!-- 陸上従業員 詳細 -->
            <admin-account-basic-info-edit
              v-if="
                $refs.adminAccountList.crewBasicInfoParam.enterprise_account_id
              "
              :inputParam="$refs.adminAccountList.crewBasicInfoParam"
              :activeSidebarCrew="activeSidebarCrew"
              @close="$refs.adminAccountList.closeSidebarCrew($event)"
              @reloadList="$refs.adminAccountList.reloadList"
              @updatedId="$refs.adminAccountList.updatedId($event)"
            />
            <!-- 陸上従業員 招待 -->
            <admin-account-invite
              v-if="
                !$refs.adminAccountList.crewBasicInfoParam.enterprise_account_id
              "
              :inputParam="$refs.adminAccountList.crewBasicInfoParam"
              :activeSidebarCrew="activeSidebarCrew"
              @close="$refs.adminAccountList.closeSidebarCrew($event)"
              @reloadList="$refs.adminAccountList.reloadList"
              @updatedId="$refs.adminAccountList.updatedId($event)"
            />
          </div>
        </template>
      </template>
    </crew-controls-sidebar>

    <div id="custom-breadcrumb-title" v-if="!this.isRouteCrewStatusList" />
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import CrewControlsSidebar from "./components/CrewControlsSidebar.vue";
import CrewAlertComponent from "./components/CrewAlertComponent.vue";
import CrewList from "../crew-list/CrewList.vue";
import CrewBasicInfoEdit from "../crew-list/components/CrewBasicInfoEdit.vue";
import CrewProfile from "../crew-profile/CrewProfile.vue";
import CrewAccountEdit from "../crew-profile/components/CrewAccountEdit.vue";
import CrewRetirementEdit from "../crew-profile/components/RetirementEdit.vue";
import CrewLabors from "../crew-labors/CrewLabors.vue";
import CrewLaborsEdit from "../crew-labors/components/CrewLaborsEdit.vue";
import CrewLaborTemplate from "../crew-labor-template/CrewLaborTemplate.vue";
import CrewLaborTemplateEdit from "../crew-labor-template/components/CrewLaborTemplateEdit.vue";
import AdminAccountList from "../admin-account-list/AdminAccountList.vue";
import AdminAccountBasicInfoEdit from "../admin-account-list/components/AdminAccountBasicInfoEdit.vue";
import AdminAccountInvite from "../admin-account-list/components/AdminAccountInvite.vue";
import ManningVesselCrewEdit from "../manning-vessels-list/components/ManningVesselCrewEdit.vue";
import ManningVesselsList from "../manning-vessels-list/ManningVesselsList.vue";
import CorpManningVesselsList from "../corp-manning-vessels-list/CorpManningVesselsList.vue";
import DataManagement from "../data-management/DataManagement.vue";
import TaskKindList from "../task-kind-list/TaskKindList.vue";
import CrewTimesheetEdit from "../crew-timesheet/components/CrewTimesheetEdit.vue";
import CrewTimesheetList from "../crew-timesheet/CrewTimesheetList.vue";
import CrewLaborRecord from "../crew-labor-record/CrewLaborRecord.vue";
import CrewStatusList from "../crew-status-list/CrewStatusList.vue";
import VesselsList from "../vessels-list/VesselsList.vue";
import VesselEdit from "../vessels-list/components/ManningVesselEdit.vue";
import authService from "@/services/authService";

import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import _ from "lodash";
import moment from "moment-timezone";

import { createNamespacedHelpers, mapGetters } from "vuex";
import { hasCrewPayroll } from "@/utils/crews/dataManagement";
const { mapActions, mapState } = createNamespacedHelpers("crewAccount");

export default {
  components: {
    CrewControlsSidebar,
    CrewAlertComponent,
    CrewList,
    CrewBasicInfoEdit,
    CrewProfile,
    CrewAccountEdit,
    CrewRetirementEdit,
    CrewLabors,
    CrewLaborsEdit,
    CrewLaborTemplate,
    CrewLaborTemplateEdit,
    AdminAccountList,
    AdminAccountBasicInfoEdit,
    AdminAccountInvite,
    ManningVesselCrewEdit,
    ManningVesselsList,
    CorpManningVesselsList,
    TaskKindList,
    CrewTimesheetEdit,
    CrewTimesheetList,
    VesselsList,
    VesselEdit,
    CrewLaborRecord,
    CrewStatusList,
    DataManagement,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      // タブで切り替え可能な画面の情報
      tabInfo: {
        labor: [
          {
            dom_id: "tab-labor-0",
            title: "勤怠情報",
            routeName: "enterprise-management-crew-labor-record",
            icon: "eventCheck",
          },
          {
            dom_id: "tab-labor-1",
            title: "打刻記録",
            routeName: "enterprise-management-crew-timesheet-list",
            icon: "crewTimesheet",
          },
          {
            dom_id: "tab-labor-2",
            title: "乗船期間",
            routeName: "enterprise-management-manning-vessels-list",
            icon: "manningVessel",
          },
          {
            dom_id: "tab-labor-3",
            title: "労務情報",
            routeName: "enterprise-management-crew-labors",
            icon: "crewLabor",
          },
          {
            dom_id: "tab-labor-4",
            title: "船員基本情報",
            routeName: "enterprise-management-crew-profile",
            icon: "clipboardNotes",
          },
        ],
        corporate: [
          {
            dom_id: "tab-corporate-0",
            title: "労務基本情報",
            routeName: "enterprise-management-crew-labor-template",
            icon: "crewLabor",
          },
          {
            dom_id: "tab-corporate-1",
            title: "船舶情報",
            routeName: "enterprise-management-crew-vessels-list",
            icon: "vesselDetail",
          },
          {
            dom_id: "tab-corporate-2",
            title: "船員一覧",
            routeName: "enterprise-management-crew-list",
            icon: "seaman",
          },
          {
            dom_id: "tab-corporate-3",
            title: "陸上従業員一覧",
            routeName: "enterprise-management-crew-admin-account-list",
            icon: "admin",
          },
          {
            dom_id: "tab-corporate-4",
            title: "乗船期間一覧",
            routeName: "enterprise-management-corp-manning-vessels-list",
            icon: "assignment",
          },
          {
            dom_id: "tab-corporate-5",
            title: "作業種別管理",
            routeName: "enterprise-management-task-kind-list",
            icon: "manageHistory",
          },
          {
            dom_id: "tab-corporate-6",
            title: "データ管理",
            routeName: "enterprise-management-data-management",
            icon: "factCheck", // TODO: アイコンの確認
            addonId: authService.ADDON_IDS.CREW_PAYROLL,
          },
        ],
      },

      alertList: [],
      activeSidebarCrew: false,
      dispType: "labor",
      activeTab: 0,
      avatar: null,
      avatarInitials: "",
      avatarName: "",
      dialogTitle: "",
      alertTileWidth: "260px",

      iconMap: {
        crewTimesheet: require(`@/assets/images/icons/crew/crew_timesheet.svg`),
        manningVessel: require(`@/assets/images/icons/crew/manning_vessel.svg`),
        crewLabor: require(`@/assets/images/icons/crew/crew_labor.svg`),
        clipboardNotes: require(`@/assets/images/icons/crew/clipboard_notes.svg`),
        vesselDetail: require(`@/assets/images/icons/crew/vessel_detail.svg`),
        seaman: require(`@/assets/images/icons/crew/seaman.svg`),
        admin: require(`@/assets/images/icons/crew/admin.svg`),
        assignment: require(`@/assets/images/icons/crew/assignment.svg`),
        manageHistory: require(`@/assets/images/icons/crew/manage_history.svg`),
        eventCheck: require(`@/assets/images/icons/crew/event_check.svg`),
        factCheck: require(`@/assets/images/icons/crew/fact_check.svg`),
      },

      crewIndex: 0,
    };
  },
  computed: {
    ...mapState({
      crewAccount: state => state.crewAccount,
      crewList: state => state.crewList,
    }),
    ...mapGetters(["addonMap"]),
    hasCrewPayroll() {
      return hasCrewPayroll(this.addonMap);
    },
    queryTab() {
      return this.$route.query.tab;
    },
    enterpriseCrewId() {
      if (this.$route.meta.dispType === "labor") {
        return this.$route.params.id;
      } else {
        return null;
      }
    },
    hasPrevCrew() {
      const findIndex = this.crewList.findIndex(
        x => x.id === this.crewAccount.id
      );
      return !isNaN(findIndex) && findIndex > 0;
    },
    hasNextCrew() {
      const findIndex = this.crewList.findIndex(
        x => x.id === this.crewAccount.id
      );
      return !isNaN(findIndex) && findIndex < this.crewList.length - 1;
    },
    isRouteCrewStatusList() {
      return this.$route.name === "enterprise-management-crew-status-list";
    },
    toBeSubtractTabAreaHeight() {
      if (this.activeTab === 0) return 180;
      return 260;
    },
    isRetirement() {
      const retirementDate = this.crewAccount.retirement_date;
      return retirementDate
        ? retirementDate <
            moment()
              .local()
              .format("YYYY-MM-DD")
        : false;
    },
    // データ管理タブの表示判定
    showDataManagement() {
      const { activeTab, hasCrewPayroll } = this;
      const isActiveTab = activeTab === 6;
      const isShow = isActiveTab && hasCrewPayroll;
      return isShow; // boolean
    },
    filteredCorporateTabInfo() {
      const { tabInfo, addonMap } = this;
      const filteredTabInfo = tabInfo.corporate.filter(item => {
        if (!Object.prototype.hasOwnProperty.call(item, "addonId")) {
          return true;
        }
        const { addonId } = item;
        return !!addonMap[addonId];
      });
      return filteredTabInfo;
    },
    filteredTabInfo() {
      const { tabInfo, filteredCorporateTabInfo } = this;
      const filteredTabInfo = {
        ...tabInfo,
        corporate: filteredCorporateTabInfo,
      };
      return filteredTabInfo;
    },
  },
  watch: {
    queryTab() {
      this.checkAlert();
      // this.setInitialTab();
    },
    enterpriseCrewId(val) {
      if (val) {
        this.initCrewAccount();
      }
    },
    activeTab() {
      this.checkAlert();
      this.dialogTitle = "";
    },
    "$route.name"() {
      this.activeTab = isNaN(this.$route.meta.tabNumber)
        ? 0
        : Number(this.$route.meta.tabNumber);
    },
  },
  methods: {
    ...mapActions([
      "setCrewAccount",
      "clearCrewAccount",
      "setCrewList",
      "getAlertList",
    ]),
    getIconFromIconMap(key) {
      // this.iconMapにkeyのキーがあるかどうか確認する
      if (_.has(this.iconMap, key)) {
        return this.iconMap[key];
      } else {
        null;
      }
    },

    initCrewAccount() {
      this.setCrewAccount(this.enterpriseCrewId).then(() => {
        const thumbnailPath = this.crewAccount.picture
          ? this.crewAccount.picture.thumbnail_path
          : null;
        this.setAvatar(thumbnailPath, this.crewAccount.name);
        this.checkAlert();
      });
      this.setCrewList({ sortOrder: "NAME_KANA" });
    },
    setAvatar(thumbnailPath, avatarName) {
      this.avatarName = avatarName;
      if (thumbnailPath) {
        storage
          .child(thumbnailPath)
          .getDownloadURL()
          .then(response => {
            this.avatar = response;
          });
      } else {
        this.avatar = null;
      }
    },

    async checkAlert() {
      this.loadingStart();
      if (this.dispType === "labor") {
        await this.setCrewAccount(this.enterpriseCrewId);
      }
      await this.setCrewList({ sortOrder: "NAME_KANA" });
      this.alertList = await this.getAlertList({ dispType: this.dispType });
      this.$nextTick(() => {
        this.loadingClose(this);
      });
    },
    jumpFromAlert(linkToObj) {
      if (this.$route.name !== linkToObj.name) {
        this.$router.push(linkToObj, () => {});
        // } else if ( linkToObj.query && !isNaN(Number(linkToObj.query.tab)) ) {  // TODO: 要確認
        //   this.activeTab = Number(linkToObj.query.tab);
      }
    },
    jumpFromTab(linkType, tabNumber) {
      const linkToObj = this.tabInfo[linkType][tabNumber].routeName;
      if (this.$route.name !== linkToObj.routeName) {
        this.$router.push({ name: linkToObj }, () => {});
      }
    },
    loadingStart() {
      this.$vs.loading({
        container: "#crew-page-layout",
        color: this.AISEA_COLOR.BLUE,
        background: "rgba(255, 255, 255, 0.4)",
      });
    },
    loadingClose: _.debounce(async self => {
      self.$vs.loading.close("#crew-page-layout > .con-vs-loading");
    }, 800),

    setInitialTab() {
      const initialTab = isNaN(this.$route.query.tab)
        ? null
        : Number(this.$route.query.tab);
      if (initialTab != null) {
        //        this.activeTab = initialTab;
        // } else {
        //   if ( this.dispType === 'labor' ) {
        //     this.activeTab = 0;
        //   } else if ( this.dispType === 'corporate' ) {
        //     this.activeTab = 3;
        //   }
      }
    },
    setDialogTitle(val) {
      this.dialogTitle = val;
    },
    onClickPrevCrew() {
      if (this.hasPrevCrew) {
        this.loadingStart();
        const findIndex = this.crewList.findIndex(
          x => x.id === this.crewAccount.id
        );
        const prevCrewId = this.crewList[findIndex - 1].id;
        this.targetCrewId = prevCrewId;
        this.$router.push({
          name: this.$route.name,
          // name: "enterprise-management-crew-labor",
          params: { id: prevCrewId },
          // query: { tab: this.activeTab },
        });
        this.$nextTick(() => {
          this.loadingClose(this);
        });
      }
    },
    onClickNextCrew() {
      if (this.hasNextCrew) {
        this.loadingStart();
        const findIndex = this.crewList.findIndex(
          x => x.id === this.crewAccount.id
        );
        const nextCrewId = this.crewList[findIndex + 1].id;
        this.targetCrewId = nextCrewId;
        this.$router.push({
          name: this.$route.name,
          // name: "enterprise-management-crew-labor",
          params: { id: nextCrewId },
          // query: { tab: this.activeTab },
        });
        this.$nextTick(() => {
          this.loadingClose(this);
        });
      }
    },
  },
  created() {
    this.dispType = this.$route.meta.dispType;
    if (this.dispType === "labor") {
      this.initCrewAccount();
    } else {
      this.clearCrewAccount();
    }
    if (this.isRouteCrewStatusList) return;
    // this.setInitialTab();
    this.activeTab = isNaN(this.$route.meta.tabNumber)
      ? 0
      : Number(this.$route.meta.tabNumber);
  },

  mounted() {
    if (this.isRouteCrewStatusList) {
      this.checkAlert();
      return;
    }
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
    this.checkAlert();

    //     this.$nextTick(() => {
    //       this.activeTab = isNaN(this.$route.meta.tabNumber) ? 0 : Number(this.$route.meta.tabNumber);
    //     });
    // console.debug("### activeTab = ", this.activeTab, this.$route.meta.tabNumber);
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
#crew-page-layout {
  font-family: $aisea-font-family;
  color: $aisea-black;

  .tabs {
    list-style-type: none;
    padding: 0;
    display: flex;
    //margin-bottom: 20px;
    overflow-x: scroll;

    /*スクロールバー非表示（IE・Edge）*/
    -ms-overflow-style: none;
    /*スクロールバー非表示（Firefox）*/
    scrollbar-width: none;
  }

  .tabs li {
    padding: 10px 20px;
    cursor: pointer;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    transition: background-color 0.2s ease-in-out;
    font-size: 16px;
  }
  .tabs li:hover:not(.active) {
    background-color: #e1e1e1;
  }

  .tabs li.active {
    cursor: default;
    border-bottom: none;
    border-top: $aisea-blue solid 3px;
    span {
      font-weight: bold;
    }
  }

  .crew-page-layout-card {
    margin-top: 1rem;
  }

  .increment-user-button {
    :hover {
      border-radius: 4px;
      background-color: $aisea-white;
    }
  }

  .retirement-badge {
    font-size: 12px;
    color: $aisea-dark-gray;
    background-color: $aisea-white;
    border-radius: 4px;
    padding: 2px 4px;
  }
}
#custom-breadcrumb-title {
  display: flex;
  align-items: center;
  position: absolute;
  padding: 0;
  margin: 0;
}
</style>
